export default __webpack_public_path__ + "static/media/cloud-upload.92e66262.svg";